import { render } from "./Proposals.vue?vue&type=template&id=1788a0e8&scoped=true"
import script from "./Proposals.vue?vue&type=script&lang=js"
export * from "./Proposals.vue?vue&type=script&lang=js"

import "./Proposals.vue?vue&type=style&index=0&id=1788a0e8&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.ordinocrm.com/releases/20260610000542/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1788a0e8"]])

export default __exports__